// Jours fériés français (fixes + mobiles calculés à partir de Pâques — algorithme de Meeus)
const cache = {};

const fmt = (d) => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;

export const getJoursFeries = (year) => {
  if (cache[year]) return cache[year];
  const a = year % 19;
  const b = Math.floor(year / 100);
  const c = year % 100;
  const d = Math.floor(b / 4);
  const e = b % 4;
  const f = Math.floor((b + 8) / 25);
  const g = Math.floor((b - f + 1) / 3);
  const h = (19 * a + b - d - g + 15) % 30;
  const i = Math.floor(c / 4);
  const k = c % 4;
  const l = (32 + 2 * e + 2 * i - h - k) % 7;
  const m = Math.floor((a + 11 * h + 22 * l) / 451);
  const month = Math.floor((h + l - 7 * m + 114) / 31);
  const day = ((h + l - 7 * m + 114) % 31) + 1;
  const paques = new Date(year, month - 1, day);
  const addDays = (n) => { const x = new Date(paques); x.setDate(paques.getDate() + n); return x; };
  const map = new Map([
    [`${year}-01-01`, "Jour de l'An"],
    [`${year}-05-01`, 'Fête du Travail'],
    [`${year}-05-08`, 'Victoire 1945'],
    [`${year}-07-14`, 'Fête nationale'],
    [`${year}-08-15`, 'Assomption'],
    [`${year}-11-01`, 'Toussaint'],
    [`${year}-11-11`, 'Armistice'],
    [`${year}-12-25`, 'Noël'],
    [fmt(addDays(1)), 'Lundi de Pâques'],
    [fmt(addDays(39)), 'Ascension'],
    [fmt(addDays(50)), 'Lundi de Pentecôte'],
  ]);
  cache[year] = map;
  return map;
};

export const getJourFerieLabel = (dateStr) => getJoursFeries(parseInt(dateStr.substring(0, 4))).get(dateStr) || null;

export const isJourFerie = (dateStr) => !!getJourFerieLabel(dateStr);

export const isJourFerieDate = (date) => isJourFerie(fmt(date));
